/* eslint-disable react/prop-types */
import { Component } from "react";
import { Alert, Badge, Button, Card, Col, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import Swal from "sweetalert2";

import equipeMultiprofissionalService from "../../api/atendimentos/equipeMultiprofissionalService";
import {
    classificacoesMedicasEquipeMultiprofissional,
    formataDataHoraExibicao,
    ordenacaoEquipeMultiprofissional,
    situacoesEquipeMultiprofissional,
} from "../../common/utils";

class EquipeMultiprofissionalAtendimento extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            salvando: false,
            ordenarPor: "categoria_profissional",
            equipeAtiva: [],
            equipeInativa: [],
            erro: "",
            showModal: false,
            formulario: this.getFormularioInicial(),
        };
    }

    componentDidMount() {
        this.carregarEquipe();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.atendimentoId !== this.props.atendimentoId ||
            prevState.ordenarPor !== this.state.ordenarPor
        ) {
            this.carregarEquipe();
        }
    }

    getFormularioInicial = () => ({
        id: null,
        categoria_profissional_id: "",
        categoria_profissional_nome: "",
        numero_registro_profissional: "",
        nome: "",
        classificacao_medica: "assistente",
    });

    getMensagemErro = (error, fallback) => {
        const data = error?.response?.data;

        if (typeof data === "string" && data.trim()) {
            return data;
        }

        if (data && typeof data === "object") {
            const primeiraChave = Object.keys(data)[0];
            const primeiroValor = data[primeiraChave];

            if (Array.isArray(primeiroValor) && primeiroValor.length > 0) {
                return primeiroValor[0];
            }

            if (typeof primeiroValor === "string" && primeiroValor.trim()) {
                return primeiroValor;
            }
        }

        return fallback;
    };

    carregarEquipe = async () => {
        const { atendimentoId } = this.props;
        const { ordenarPor } = this.state;

        if (!atendimentoId) {
            this.setState({
                equipeAtiva: [],
                equipeInativa: [],
                loading: false,
            });
            return;
        }

        this.setState({ loading: true, erro: "" });

        try {
            const response = await equipeMultiprofissionalService.listar(atendimentoId, ordenarPor);
            const data = response.data || {};

            this.setState({
                equipeAtiva: Array.isArray(data.ativos) ? data.ativos : [],
                equipeInativa: Array.isArray(data.inativos) ? data.inativos : [],
                loading: false,
            });
        } catch (error) {
            console.error("Erro ao carregar equipe multiprofissional:", error);
            this.setState({
                erro: this.getMensagemErro(error, "Não foi possível carregar a equipe multiprofissional."),
                loading: false,
            });
        }
    };

    resetFormulario = () => {
        this.setState({ formulario: this.getFormularioInicial() });
    };

    abrirModalNovo = () => {
        this.resetFormulario();
        this.setState({ showModal: true });
    };

    abrirModalEdicao = (profissional) => {
        this.setState({
            formulario: {
                id: profissional.id,
                categoria_profissional_id: profissional?.dados_categoria_profissional?.id || "",
                categoria_profissional_nome: profissional?.dados_categoria_profissional?.nome || "",
                numero_registro_profissional: profissional?.numero_registro_profissional || "",
                nome: profissional?.nome || "",
                classificacao_medica: profissional?.classificacao_medica || "assistente",
            },
            showModal: true,
        });
    };

    fecharModal = () => {
        if (this.state.salvando) return;

        this.setState({ showModal: false }, () => {
            this.resetFormulario();
        });
    };

    atualizarCampo = (event) => {
        const { name, value } = event.target;

        this.setState((prevState) => ({
            formulario: {
                ...prevState.formulario,
                [name]: value,
            },
        }));
    };

    atualizarCategoriaProfissional = (option) => {
        this.setState((prevState) => ({
            formulario: {
                ...prevState.formulario,
                categoria_profissional_id: option?.value || "",
                categoria_profissional_nome: option?.label || "",
            },
        }));
    };

    validarFormulario = () => {
        const { formulario } = this.state;

        if (!formulario.categoria_profissional_id) {
            Swal.fire("Atencao", "Selecione a categoria profissional.", "warning");
            return false;
        }

        if (!String(formulario.numero_registro_profissional || "").trim()) {
            Swal.fire("Atencao", "Informe o número de registro profissional.", "warning");
            return false;
        }

        if (!String(formulario.nome || "").trim()) {
            Swal.fire("Atencao", "Informe o nome do profissional.", "warning");
            return false;
        }

        if (!formulario.classificacao_medica) {
            Swal.fire("Atencao", "Selecione a classificação médica.", "warning");
            return false;
        }

        return true;
    };

    salvarProfissional = async () => {
        const { atendimentoId } = this.props;
        const { formulario } = this.state;

        if (!this.validarFormulario()) {
            return;
        }

        const payload = {
            categoria_profissional_id: formulario.categoria_profissional_id,
            numero_registro_profissional: String(formulario.numero_registro_profissional || "").trim(),
            nome: String(formulario.nome || "").trim(),
            classificacao_medica: formulario.classificacao_medica,
        };

        this.setState({ salvando: true });

        try {
            if (formulario.id) {
                await equipeMultiprofissionalService.update(formulario.id, payload);
            } else {
                await equipeMultiprofissionalService.create({
                    atendimento_id: atendimentoId,
                    ...payload,
                });
            }

            this.setState({ showModal: false, salvando: false }, async () => {
                this.resetFormulario();
                await this.carregarEquipe();
            });

            Swal.fire(
                "Sucesso",
                formulario.id
                    ? "Profissional atualizado com sucesso."
                    : "Profissional adicionado com sucesso.",
                "success"
            );
        } catch (error) {
            console.error("Erro ao salvar profissional da equipe multiprofissional:", error);
            this.setState({ salvando: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível salvar o profissional."), "error");
        }
    };

    inativarProfissional = async (profissional) => {
        const confirmacao = await Swal.fire({
            title: "Confirmar inativação?",
            text: `Deseja inativar ${profissional?.nome || "este profissional"}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, inativar",
            cancelButtonText: "Cancelar",
        });

        if (!confirmacao.isConfirmed) {
            return;
        }

        try {
            await equipeMultiprofissionalService.delete(profissional.id);
            await this.carregarEquipe();
            Swal.fire("Sucesso", "Profissional inativado com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao inativar profissional da equipe multiprofissional:", error);
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível inativar o profissional."), "error");
        }
    };

    renderSituacaoBadge = (situacao) => {
        const label = situacoesEquipeMultiprofissional[situacao] || situacao || "-";
        const bg = situacao === "ativo" ? "success" : "secondary";
        return <Badge bg={bg}>{label}</Badge>;
    };

    renderTabela = (profissionais, tipo = "ativo") => {
        const { permiteEdicao, finalizado, cancelado } = this.props;
        const exibirAcoes = tipo === "ativo" && permiteEdicao && !finalizado && !cancelado;
        const exibirDataInativacao = tipo === "inativo";

        return (
            <Table responsive className="custom-table table-sm align-middle mb-0">
                <thead>
                    <tr>
                        <th>Categoria Profissional</th>
                        <th>Número de Registro</th>
                        <th>Nome</th>
                        <th>Classificação Médica</th>
                        <th>Situação</th>
                        <th>Data Cadastro</th>
                        {exibirDataInativacao && <th>Data de Inativação</th>}
                        {exibirAcoes && <th className="text-left">Ações</th>}
                    </tr>
                </thead>
                <tbody>
                    {profissionais.length === 0 ? (
                        <tr>
                            <td colSpan={6 + (exibirDataInativacao ? 1 : 0) + (exibirAcoes ? 1 : 0)} className="text-center">
                                Nenhum profissional encontrado.
                            </td>
                        </tr>
                    ) : (
                        profissionais.map((profissional) => (
                            <tr key={profissional.id}>
                                <td>{profissional?.dados_categoria_profissional?.nome || "-"}</td>
                                <td>{profissional?.numero_registro_profissional || "-"}</td>
                                <td>{profissional?.nome || "-"}</td>
                                <td>{classificacoesMedicasEquipeMultiprofissional[profissional?.classificacao_medica] || "-"}</td>
                                <td>{this.renderSituacaoBadge(profissional?.situacao)}</td>
                                <td>{profissional?.data_cadastro ? formataDataHoraExibicao(profissional.data_cadastro) : "-"}</td>
                                {exibirDataInativacao && (
                                    <td>{profissional?.data_inativacao ? formataDataHoraExibicao(profissional.data_inativacao) : "-"}</td>
                                )}
                                {exibirAcoes && (
                                    <td className="text-end">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            className="me-2"
                                            onClick={() => this.abrirModalEdicao(profissional)}
                                        >
                                            Editar
                                        </Button>
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={() => this.inativarProfissional(profissional)}
                                        >
                                            Inativar
                                        </Button>
                                    </td>
                                )}
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        );
    };

    render() {
        const { permiteEdicao, finalizado, cancelado } = this.props;
        const { loading, salvando, ordenarPor, equipeAtiva, equipeInativa, erro, showModal, formulario } = this.state;

        const bloqueadoEdicao = !permiteEdicao || finalizado || cancelado;

        return (
            <>
                <Card className="cardDestaque mt-2">
                    <Card.Body>
                        <Row className="align-items-end mb-3">
                            <Col md={5} lg={4}>
                                <Form.Group>
                                    <Form.Label>Ordenar por</Form.Label>
                                    <Form.Select
                                        value={ordenarPor}
                                        onChange={(event) => this.setState({ ordenarPor: event.target.value })}
                                        disabled={loading}
                                    >
                                        {Object.entries(ordenacaoEquipeMultiprofissional).map(([valor, label]) => (
                                            <option key={valor} value={valor}>
                                                {label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={7} lg={8} className="text-md-end mt-3 mt-md-0">
                                {!bloqueadoEdicao && (
                                    <Button variant="success" size="sm" onClick={this.abrirModalNovo}>
                                        Adicionar profissional
                                    </Button>
                                )}
                            </Col>
                        </Row>

                        {bloqueadoEdicao && (
                            <Alert variant="warning">
                                A equipe multiprofissional está disponível apenas para visualização porque o atendimento não pode mais ser alterado.
                            </Alert>
                        )}

                        {erro && <Alert variant="danger">{erro}</Alert>}

                        {loading ? (
                            <div className="text-center py-4">
                                <Spinner animation="border" />
                            </div>
                        ) : (
                            <>
                                <Card className="mb-4">
                                    <Card.Body>
                                        <h5 className="mb-3">Equipe ativa</h5>
                                        {this.renderTabela(equipeAtiva, "ativo")}
                                    </Card.Body>
                                </Card>

                                <Card>
                                    <Card.Body>
                                        <h5 className="mb-3">Equipe inativa</h5>
                                        {this.renderTabela(equipeInativa, "inativo")}
                                    </Card.Body>
                                </Card>
                            </>
                        )}
                    </Card.Body>
                </Card>

                <Modal show={showModal} onHide={this.fecharModal} size="lg" centered>
                    <Modal.Header closeButton={!salvando}>
                        <Modal.Title>{formulario.id ? "Editar profissional" : "Adicionar profissional"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Categoria Profissional</Form.Label>
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        loadOptions={equipeMultiprofissionalService.loadCategoriasProfissionais}
                                        placeholder="Buscar categoria..."
                                        noOptionsMessage={() => "Nenhuma categoria encontrada"}
                                        onChange={this.atualizarCategoriaProfissional}
                                        value={
                                            formulario.categoria_profissional_id
                                                ? {
                                                    value: formulario.categoria_profissional_id,
                                                    label: formulario.categoria_profissional_nome || "Selecionada",
                                                }
                                                : null
                                        }
                                        isDisabled={salvando}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Número de registro profissional</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="numero_registro_profissional"
                                        value={formulario.numero_registro_profissional}
                                        onChange={this.atualizarCampo}
                                        disabled={salvando}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={7}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nome"
                                        value={formulario.nome}
                                        onChange={this.atualizarCampo}
                                        disabled={salvando}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={5}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Classificação médica</Form.Label>
                                    <Form.Select
                                        name="classificacao_medica"
                                        value={formulario.classificacao_medica}
                                        onChange={this.atualizarCampo}
                                        disabled={salvando}
                                    >
                                        {Object.entries(classificacoesMedicasEquipeMultiprofissional).map(([valor, label]) => (
                                            <option key={valor} value={valor}>
                                                {label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModal} disabled={salvando}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={this.salvarProfissional} disabled={salvando}>
                            {salvando ? <Spinner animation="border" size="sm" /> : "Salvar"}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default EquipeMultiprofissionalAtendimento;
